import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=6afc6fb0&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=6afc6fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afc6fb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6afc6fb0')) {
      api.createRecord('6afc6fb0', component.options)
    } else {
      api.reload('6afc6fb0', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=6afc6fb0&scoped=true&", function () {
      api.rerender('6afc6fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/campaign/components/Question.vue"
export default component.exports